<template>
  <div class="login_modal">
    <!-- <div class="mask"></div> -->
    <div class="login">
      <!-- 关闭图标 -->
      <div class="closeDialog" @click="changeLoginBox(false)">
        <img src="@/assets/images/close.png" alt="" />
      </div>
      <div class="title">
        <span
          @click="switchLogin()"
          :class="
            this.$store.state.isShowDefaultLogin == true ? 'currentSelect' : ''
          "
          >登录</span
        >
        <span
          @click="switchRegister()"
          :class="
            this.$store.state.isShowDefaultLogin == false ? 'currentSelect' : ''
          "
          >注册</span
        >
      </div>

      <div class="loginRegion" v-if="this.$store.state.isShowDefaultLogin">
        <input
          @keyup.enter="login()"
          type="text"
          placeholder="账号"
          v-model="loginDTO.account"
        >
        <input
          @keyup.enter="login()"
          type="password"
          placeholder="密码"
          v-model="loginDTO.password"
        />
        <div>
          <input
            type="text"
            placeholder="验证码"
            v-model="loginDTO.verifyCode"
            @keyup.enter="login()"
          />
          <div
            class="login-code"
            @click="getVerificationCodeImg(loginCode.loginCodeKey)"
          >
            <img
              v-if="isCodeSucess"
              :src="loginCode.imageBase64"
              alt=""
              title="刷新验证码"
            />
            <span v-else  
              >加载失败（重试）</span
            >
          </div>
        </div>
        <button @click="login()">
          <span v-if="!loginLoading">登 录</span>
          <span v-else>登 录 中...</span>
        
        </button>
      </div>
      <div class="registerRegion" v-else>
        <input
          type="text"
          @keyup.enter="register()"
          placeholder="账号"
          v-model="registerDTO.account"
        />
        <input
          type="password"
          @keyup.enter="register()"
          placeholder="密码"
          v-model="registerDTO.password"
        />
        <input
          type="password"
          v-model="registerDTO.confirmPassword"
          @keyup.enter="register()"
          placeholder="再次输入密码"
        />
        <input
          type="text"
          placeholder="手机号"
          @keyup.enter="register()"
          v-model="registerDTO.phone"
        />
        <div v-show="false">
          <input
            type="text"
            placeholder="验证码"
            @keyup.enter="register()"
            v-model="registerDTO.code"
          />
          <div>
            <span v-if="reSendCode" @click="sendCode()">获取验证码</span>
            <span v-else>重新获取({{ remainSecond }})</span>
          </div>
        </div>
        <button @click="register()">
          <span v-if="!registerLoading">注 册</span>
          <span v-else>注 册 中...</span>
      
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import {
  GetVerificationCodeImgAPI,
  LoginAPI,
  RegisterAPI,
} from "@/request/user/api.js";

export default {
  data() {
    return {
      reSendCode: true, //是否发送验证码
      remainSecond: 60, //验证码多少秒后在发送
      timer: null, //防止多次发送验证码
      isCodeSucess: true, //验证码是否发送成功
      loginDTO: {},
      registerDTO: {},
      loginCode: {},
      loginLoading: false,
      registerLoading: false,
      //验证码base64
    };
  },

  created() {
    if (this.$store.state.isShowLoginBox&&this.$store.state.isShowDefaultLogin) {
      this.getVerificationCodeImg(this.loginCode.loginCodeKey);
    }
  },
  watch: {
    "$store.state.isShowLoginBox": {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.getVerificationCodeImg(this.loginCode.loginCodeKey);
        }
      },
    },
  },
  methods: {
    ...mapMutations([
      "changeLoginBox",
      "changeTopBarNoLoginBox",
      "changeDefaultLoginState",
      "changeUserId",
    ]),

    sendCode() {
      this.reSendCode = false;
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.remainSecond -= 1;
          if (this.remainSecond == 0) {
            clearInterval(this.timer);
            this.reSendCode = true;
            this.timer = null;
            this.remainSecond = 60;
          }
        }, 1000);
      }
    },
    switchLogin() {
      this.changeDefaultLoginState(true);
      this.getVerificationCodeImg(this.loginCode.loginCodeKey);
    },
    switchRegister() {
      this.changeDefaultLoginState(false);
    },

    async login() {
      if (this.loginLoading) {
        return;
        
      }
      if (!this.loginDTO.account || !this.loginDTO.password) {
        this.$message.error("请输入用户名或密码");
        return;
      }
      if (!this.loginDTO.verifyCode) {
        this.$message.error("请输入验证码");
        return;
      }
      let loginDto = { ...this.loginDTO, key: this.loginCode.loginCodeKey };
      this.loginLoading=true;
      let data = await LoginAPI(loginDto);
      this.loginLoading=false;
      if (data.code == 200) {
        this.$message.success(data.msg);
        console.log(data.data);
        localStorage.setItem("user-token", data.data.token);

        localStorage.setItem("user-id", data.data.user.id);
        localStorage.setItem("user-img", data.data.user.headImageAddress),
          localStorage.setItem("user-nickname", data.data.user.nickname);
        localStorage.setItem("user-nickname", data.data.user.nickname);
        localStorage.setItem("user-fillState", data.data.user.fillInfo);
        this.$store.state.userId = data.data.user.id;
        this.$store.state.userFillState = data.data.user.fillInfo;
        //隐藏登录框和tobar中的未登录框
        this.changeLoginBox(false);
        this.changeTopBarNoLoginBox(false);
        this.changeUserId(data.data.user.id);
        this.$store.state.userImg =
          this.imgUrl + data.data.user.headImageAddress;
        this.$store.state.userName = data.data.user.nickname;
        //清空账号和密码
        this.loginDTO.account = "";
        this.loginDTO.password = "";
        this.loginDTO.verifyCode = "";
        this.webSocket.getInstance(); //初始化websocket
        if (
          !this.$store.state.userFillState ||
          this.$store.state.userFillState == "0"
        ) {
          this.$router.push("/welcome");
          return;
        }
        if (this.$store.state.redirectUrl != "") {
          if (this.$store.state.redirectUrl == window.location.pathname) {
            //刷新
            this.$router.go(0);
          } else {
            this.$router.push(this.$store.state.redirectUrl);
          }
          this.$store.state.redirectUrl = "";
        }
      } else {
        // 刷新验证码图片
        this.$message.error(data.msg);
        this.getVerificationCodeImg(this.loginCode.loginCodeKey);
      }
    },
    async register() {
      if (this.registerLoading) {
        return;
        
      }

      if (!this.registerDTO.account) {
        this.$message.error("请输入账号");
        return;
      }
      if (!this.registerDTO.password) {
        this.$message.error("请输入密码");
        return;
      }
      if (!this.registerDTO.confirmPassword) {
        this.$message.error("请再次输入密码");
        return;
      }
      if (this.registerDTO.password !== this.registerDTO.confirmPassword) {
        this.$message.error("两次密码不一致");
        return;
      }
      if (!this.registerDTO.phone) {
        this.$message.error("请输入手机号");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.registerDTO.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      // if (!this.registerDTO.code) {
      //   this.$message.error("请输入验证码");
      //   return;
      // }
      this.registerLoading=true
      let data = await RegisterAPI(this.registerDTO);
      this.registerLoading=false
      if (data.code == 200) {
        this.$store.state.isShowDefaultLogin = true;
        //清空账号和密码
        this.registerDTO.account = "";
        this.registerDTO.password = "";
        this.registerDTO.confirmPassword = "";
        this.registerDTO.phone = "";
        this.registerDTO.code = "";
        this.$message.success(data.msg);
      } else {
        this.$message.error(data.msg);
      }
    },
    async getVerificationCodeImg(key) {
      let data = await GetVerificationCodeImgAPI(key);
      if (data.code == 200) {
        this.isCodeSucess = true;
        this.loginCode = data.data;
      } else {
        this.isCodeSucess = false;
      }
      console.log(this.loginCode);
    },
  },
};
</script>

<style lang="less" scope>
.login_modal {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 22;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .login {
    box-sizing: border-box;
    padding: 20px 20px 50px;
    width: 500px;

    box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px,
      rgba(0, 0, 0, 0.22) 0px 15px 12px;
    background-color: white;
    position: relative;

    .closeDialog {
      position: absolute;
      right: 10px;
      top: 10px;
      padding: 5px 5px;

      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 20px;
      }
      &:hover {
        background-color: #ccc;
        cursor: pointer;
      }
    }
    .title {
      width: 200px;
      margin: 20px auto;
      display: flex;
      justify-content: space-between;
      span {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .currentSelect {
        font-size: 20px;
        color: #24ade1;
      }
    }
    .loginRegion {
      display: flex;
      flex-direction: column;
      align-items: center;
      > input {
        box-sizing: border-box;

        border: 1px solid #ccc;
        height: 40px;
        width: 400px;
        padding: 0 20px;
        margin-bottom: 20px;
      }
      div {
        height: 40px;
        width: 400px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        input {
          box-sizing: border-box;
          width: 200px;
          height: 40px;
          border: 1px solid #ccc;
          padding: 0 20px;
        }
        div {
          width: 150px;
          display: flex;
          justify-content: right;

          img {
            border: 1px solid #ccc;
            width: 100px;
            cursor: pointer;
            height: 50px;
          }
          span {
            color: #606266; 
            font-size: 14px;
            &:hover{
             color: #24ade1;
             cursor: pointer;
            }
         
        
          }
        }
      }
      button {
        margin-top: 20px;
        height: 40px;
        width: 400px;
        border: 0;
        background-color: #24adde;
        color: white;
        cursor: pointer;
      }
    }
    .registerRegion {
      display: flex;
      flex-direction: column;
      align-items: center;
      > input {
        box-sizing: border-box;
        border: 1px solid #ccc;
        height: 40px;
        width: 400px;
        padding: 0 20px;
        margin-bottom: 20px;
      }
      > div {
        height: 40px;
        width: 400px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #ccc;
        input {
          box-sizing: border-box;
          width: 200px;
          height: 40px;
          padding: 0 20px;
          flex: 1;
        }
        div {
          width: 100px;
          height: 40px;
          line-height: 40px;
          color: #24ade1;
          cursor: pointer;
          text-align: center;
          // color: rgb(204, 204, 204);
        }
      }
      button {
        margin-top: 20px;
        height: 40px;
        width: 400px;
        border: 0;
        background-color: #24adde;
        color: white;
        cursor: pointer;
      }
    }
  }
}
</style>